$(function(){

    /*
        Paso 1
    */
    var id = 0;
    var precio_adulto = 0;
    var total_adultos = 0;
    var total_precio_adultos = 0;
    var precio_niños = 0;
    var total_niños= 0;
    var total_precio_niños = 0;
    var precio_bebes = 0;
    var total_bebes = 0;
    var total_precio_bebes = 0;
    var $body = $('body');
    var $form = $('#form_paso1');
    var pathname = $(location).attr('origin');

    function _total(){
        if(!total_precio_bebes){
            total_precio_bebes = 0;
        }
        if(!total_precio_niños){
            total_precio_niños = 0;
        }
        var total = total_precio_adultos + total_precio_niños + total_precio_bebes;
        $('#total').html(total + ' €');
    }

    function _actualizarAdultos(){
        precio_adulto = $('#adultos').data('precio');
        total_adultos = $('#adultos').val();
        total_precio_adultos = precio_adulto * total_adultos;

        $('#precio_adulto').html('Adultos: ' + precio_adulto + '€' + '<span class="text__black" id="total_adulto"> x '+ total_adultos +'</span>');
    }
    function _actualizarBebes(){
        precio_bebes = $('#bebes').data('precio');
        if(precio_bebes == 'Gratis' || precio_bebes == 'gratis' ){
            precio_bebes__ = 'Gratis';
            precio_bebes = 0;
        }else{
            precio_bebes__ = precio_bebes + '€';
        }
        total_bebes = $('#bebes').val();
        total_precio_bebes = precio_bebes * total_bebes;
        if(total_precio_bebes){
           $('#precio_bebes').html('Bebes: ' + precio_bebes__ + '<span class="text__black" id="total_adulto"> x '+ total_bebes +'</span>');            
        }
    }
    function _actualizarMenores(){
       
        precio_niños = $('#niños').data('precio');
        total_niños = $('#niños').val();
        total_precio_niños = precio_niños * total_niños;
        if(total_precio_niños){
            $('#precio_niños').html('Niños: ' + precio_niños + '€' + '<span class="text__black" id="total_adulto"> x '+ total_niños +'</span>');
        }
    }

    function _update(){
        _actualizarAdultos();
        _actualizarBebes();
        _actualizarMenores();
        _total();
    }

    $('body').on('change', '#adultos', function() {
        _actualizarAdultos();
        _total();
    });
    $('body').on('change', '#bebes', function() {
        _actualizarBebes();
        _total();
    });
    $('body').on('change', '#niños', function() {
        _actualizarMenores();
        _total();
    });

    $form.on('click', '> #form_paso1_envio', function(e){
        e.preventDefault();
        id = $form.find('input[name=paquete_id]').val();
        page = $(this).data('page');
        if(!total_bebes){
            total_bebes = 0;
        }
        if(!total_niños){
            total_niños = 0;
        }
        window.location.href = pathname + '/'+page+'/paso2/' + id + '/'+ total_adultos + '/' + total_bebes + '/' + total_niños;
    });
    
    /*
        Paso 2
    */
    var agencia_form_islaid = 0;
    var $form2 = $('#form_paso2');
    
    $('#form_paso2_envio').click(function (e){
        e.preventDefault();
        total_adultos = $body.find('input[name=total_adultos]').val();
        total_bebes = $body.find('input[name=total_bebes]').val();
        total_niños = $body.find('input[name=total_niños]').val();
        id = $body.find('input[name=paquete_id]').val(); 

        agencia_id = $('#datos_agencia').find('input[name=agencia_id]').val();
        page = $(this).data('page');
        
        window.location.href = pathname + '/'+page+'/paso3/' + id + '/'+ total_adultos + '/' + total_bebes + '/' + total_niños + '/' + agencia_id;
    });

    /*
        Paso 3
    */
    $('#form_paso3').submit(function (e){
        e.preventDefault();
        params = $(this).serialize();
        email = $('#email_agencia').data('email'); 
        page = $('#form_paso3_envio').data('page');
        if(page == 'presupuestos') {
            tipo = '_nuevo_presupuesto';
        }else{
            tipo = '_nuevo_carro';            
        }

        $.ajax({ 
            url: '/views/layouts/resrevas/' + tipo + '.php', 
            dataType: 'html', 
            data: params, 
            type: 'POST', 
            success: function(response) { 
                if(tipo == '_nuevo_carro'){
                    $('#redsys_div').html(response);
                    setTimeout(() => {
                        var redsys = $('#redsys_div').find('form');
                        redsys.submit();
                    }, 200);
                }else{
                    window.location.href = pathname + '/' + page + '/confirmacion/' + response ;
                }
            }, 
        }); 
    });
    /*
        Paso confirmación [Descarga]
    */
    $('#descarga').click(function (e){
        e.preventDefault();
        window.print();
    });

    _update();
});


// WEBPACK FOOTER //
// ./assets/js/reserva.js